module.exports = {"411221100":"城关镇","411221101":"英豪镇","411221102":"张村镇","411221103":"洪阳镇","411221104":"天池镇","411221105":"仰韶镇","411221203":"仁村乡","411221206":"果园乡","411221207":"陈村乡","411221208":"坡头乡","411221209":"段村乡","411221210":"南村乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411221.json
// module id = 1632
// module chunks = 0